module.exports = __webpack_public_path__ + "img/normal-you4.aa04d66e.png";